import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';

export const getRecipientAriaLabel = (recipient: FindRecipientPersonaType) =>
    recipient.EmailAddress.Name && recipient.EmailAddress.EmailAddress
        ? `${recipient.EmailAddress.Name} (${recipient.EmailAddress.EmailAddress})`
        : recipient.EmailAddress.Name || recipient.EmailAddress.EmailAddress || null;
